import React from 'react'
import { Link } from 'react-router-dom'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import LogoRainAnimation from './rain'

export default function Hero() {
  useGSAP(() => {
    var tl = gsap.timeline()

    tl.from('.hero img, .hero p', {
      y: 100,
      duration: 0.8,
      delay: 0.8,
      opacity: 0,
      stagger: 0.3,
    })
  }, [])

  return (
    <>
      <div className='hero relative lg:h-[875px] md:flex flex-col justify-center hidden'>
        <img
          src='/images/bit-yellow.png'
          alt='bit-yellow'
          width={40}
          height={40}
          className='absolute left-[10%] buttom-[10%] animated-image'
        />
        <img
          src='/images/bit-yellow.png'
          alt='bit-yellow'
          width={40}
          height={40}
          className='absolute left-[5%] bottom-[30%] animated-image'
        />
        <div className='absolute right-5 top-24'>
          <Link
            hrefLang='/'
            className='rotating-element block'
          >
            <img
              src='/images/telegram.png'
              alt='twitter'
              width={50}
              height={50}
            />
          </Link>
          <Link
            hrefLang='/'
            className='mt-2 block rotating-element'
          >
            <img
              src='/images/twitter.png'
              alt='twitter'
              width={50}
              height={50}
            />
          </Link>
        </div>
        <div className='grid grid-cols-2 lg:mt-20 lg:px-20 md:px-10 px-4'>
          <div></div>
          <div className='flex flex-col justify-center items-center'>
            <img
              src='/images/bitcoin-pizaa.png'
              alt='bitcoin-pizaa'
              className='lg:w-[169px] lg:h-[65px] block '
            />
            <img
              src='/images/btc pizza 1.png'
              alt='btc pizza 1'
              className='md:w-[557px] w-[200px] md:h-[311px] h-[200px] object-contain'
            />
            <p className='w-full max-w-[300px] text-center mt-5'>
              Welcome to Bitcoin Pizza Day Token and celebrate the legendary
              first Bitcoin purchase with us. Join our community and make every
              day a slice of history!
            </p>
            <div className='lg:ml-20 mt-5 '>
              <Link
                hrefLang='/'
                className='mt-2 block'
              >
                <img
                  src='/images/buy-now.png'
                  alt='buy-now'
                  className='lg:w-[315px] lg:h-[72px] '
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* mobile  */}
      <div className='hero h-[1150px] relative md:hidden flex flex-col justify-end items-center'>
        <div className='flex flex-col justify-end items-center'>
          <img
            src='/images/bitcoin-pizaa.png'
            alt='bitcoin-pizaa'
            className='w-[169px] h-[65px] block '
          />
          <img
            src='/images/btc pizza 1.png'
            alt='btc pizza 1'
            className=' w-[300px] h-[180px] object-contain'
          />
          <p className='w-full max-w-[300px] text-center mt-5'>
            Welcome to Bitcoin Pizza Day Token and celebrate the legendary first
            Bitcoin purchase with us. Join our community and make every day a
            slice of history!
          </p>
          <div className='ml-20 mt-5 '>
            <Link
              hrefLang='/'
              className='mt-2 block'
            >
              <img
                src='/images/buy-now.png'
                alt='buy-now'
                className='w-[315px] h-[72px]'
              />
            </Link>
          </div>
          <img
            src='/images/mobile-pizza.png'
            alt='mobile-pizza'
            className='  '
          />
        </div>
      </div>
    </>
  )
}
